export const RECEIVE_PROJECTS = 'RECEIVE_PROJECTS';
export const FETCH_PROJECT = 'FETCH_PROJECT';
export const RECEIVE_PERSONS = 'RECEIVE_PERSONS';
export const FETCH_PERSON = 'FETCH_PERSON';
export const RECEIVE_NEWS = 'RECEIVE_NEWS';
export const FETCH_ARTICLE = 'FETCH_ARTICLE';
export const RECEIVE_NAVIGATION = 'RECEIVE_NAVIGATION';
export const RECEIVE_PAGE = 'RECEIVE_PAGE';
export const RECEIVE_INVESTORS_TYPES = 'RECEIVE_INVESTORS_TYPES';
export const FETCH_INVESTORS_TYPES = 'FETCH_INVESTORS_TYPES';
export const RECEIVE_INVESTORS_GEOGRAPHIES = 'RECEIVE_INVESTORS_GEOGRAPHIES';
export const FETCH_INVESTORS_GEOGRAPHIES = 'FETCH_INVESTORS_GEOGRAPHIES';
export const CHANGE_MENU_STATE = 'CHANGE_MENU_STATE';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_CURRENT_TAB = 'SET_CURRENT_TAB';
export const SET_CURRENT_PERSON = 'SET_CURRENT_PERSON';
export const SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT';
export const SET_CURRENT_ARTICLE = 'SET_CURRENT_ARTICLE';
export const SET_POPUP_STATE = 'SET_POPUP_STATE';
export const SET_FADER = 'SET_FADER';
export const PAGE_IS_AUTO_SCROLLING = 'PAGE_IS_AUTO_SCROLLING';
export const SET_ERROR_PAGE_STATE = 'SET_ERROR_PAGE_STATE';
export const LOADED_PAGE = 'LOADED_PAGE';
export const READY_PAGE = 'READY_PAGE';
export const SET_LANG = 'SET_LANG';
export const IS_MOBILE = 'IS_MOBILE';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js